import QuestionLibraryList from "pages/ManagementPage/questionSection/QuestionLibraryList/QuestionLibraryList";

export default QuestionLibraryList;
